<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!purchasesDelivery">
      <span class="loader"></span>
    </span>
    <div v-if="purchasesDelivery" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        :value="currentTab"
        @onTabChanged="tabChanged"
      >
        <tab-pane title="global" id="1" :active="false">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <purchases-delivery-view-global
            :purchasesDelivery="purchasesDelivery"
          />
        </tab-pane>

        <tab-pane title="details" id="2" :active="false">
          <span slot="title">
            <i class="ni ni-bullet-list-67"></i>
            {{ $t("COMMON.DETAILS") }}
          </span>
          <purchases-delivery-view-details
            :purchasesDelivery="purchasesDelivery"
            @purchasesDeliveryItemsUpdated="get"
          />
        </tab-pane>

        <tab-pane
          title="files"
          id="998"
          v-if="
            $currentUserCan($permissions.PERM_VIEW_ANY_FILES) &&
            purchasesDelivery.organization
          "
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component :object="purchasesDelivery" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <purchases-delivery-view-logs
            :purchasesDelivery="purchasesDelivery"
          />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import PurchasesDeliveryViewGlobal from "../partials/PurchasesDeliveryViewGlobal.vue";
import PurchasesDeliveryViewDetails from "../partials/PurchasesDeliveryViewDetails.vue";
import PurchasesDeliveryViewLogs from "../partials/PurchasesDeliveryViewLogs.vue";
import hasTabs from "@/mixins/has-tabs";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    PurchasesDeliveryViewGlobal,
    PurchasesDeliveryViewDetails,
    PurchasesDeliveryViewLogs,
    ListFileComponent,
  },

  mixins: [requestErrorMixin, hasTabs],

  props: {
    purchasesDeliveryId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      purchasesDelivery: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch(
          "purchasesDeliveries/get",
          this.purchasesDeliveryId
        );
        this.purchasesDelivery =
          this.$store.getters["purchasesDeliveries/purchasesDelivery"];
        this.$emit("purchasesDeliveryLoaded", this.purchasesDelivery);
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
